import { Utilities } from "@learningblocks/exp-constants";
const { checkSlidersCorrect, resetUpdatedKeyInDNDQ, VISIBILITY } = Utilities;
const NEXT_COMPONENT = "nextComponent";

export function submitAnswer(state, payload) {
  return {
    ...state,
    currentChapter: updateSubmitInCurrentChapter(state.currentChapter, payload),
  };
}

function updateSubmitInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: updateSubmitInComponents(currentChapter.components, payload),
  };
}

/**
 *
 * @param {'Array<Object>'} components array of components
 * @param {'number'} payload component ID
 * @returns
 */
function updateSubmitInComponents(components, payload) {
  const { newcomponents } = components.reduce(
    (acc, component) => {
      // updating submitted component
      if (component.id === payload) {
        component = updateSubmitInDNDQComponent(component);
        if (Object.hasOwn(component, NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating forward component and setting its visibility
      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        component = { ...component, visibility: VISIBILITY.VISIBLE };
        acc.forward = null;
      }
      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      newcomponents: [],
      forward: null,
    }
  );
  return newcomponents;
}

function updateSubmitInDNDQComponent(component) {
  if (component.totalAttempts === -10 || component.totalAttempts > 0) {
    const complete = checkSlidersCorrect(component.sliders);
    let sliders = resetUpdatedKeyInDNDQ(component.sliders);
    if (complete) {
      sliders = sliders.map(disableSlider);
    }
    const totalAttempts =
      component.totalAttempts === -10 ? -10 : component.totalAttempts - 1;
    return {
      ...component,
      complete,
      sliders,
      totalAttempts,
      showFeedback: true,
    };
  } else {
    return {
      ...component,
      complete: true,
      showFeedback: true,
      totalAttempts: 0,
    };
  }
}

function disableSlider(slider) {
  return { ...slider, disable: true };
}
